import { Box, InputAdornment, TextField, useTheme } from "@material-ui/core";
import {
  assetIds,
  ThemedAsset,
  emailPattern,
  phonePattern,
  InformationMessage,
} from "nemuru-components";
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { Typography } from "@material-ui/core";
import { ICON_TITLE_HEIGHT } from "../../../../../../../../config/config";
import { ProcessContext } from "../../../../../../../../contexts/ProcessContext";
import IconTitle from "../../../../../../../shared/components/IconTitle";
import MainButton from "../../../../../../../shared/components/MainButton";
import Text from "../../../../../../../shared/components/Text";
import { PHONE_NUMBER_PREFIX } from "../../../../config";
import { CAIXABANK_CO_BORROWER_NOTICE } from "../constants/CAIXABANK_CO_BORROWER_NOTICE";
import { getRoleTextIdVariantByParticipant } from "../utils/getRoleTextVariantByParticipant";
import { ConfigContext } from "../../../../../../../../contexts/ConfigContext";

export const ParticipantContactData = ({
  onSubmitForm,
  data,
  selectedRole,
}) => {
  const {
    state: { loading, loan },
  } = useContext(ProcessContext);
  const {
    state: { dictionaryValues },
  } = useContext(ConfigContext);

  const { palette } = useTheme();
  const { register, getValues, handleSubmit, errors } = useForm({
    defaultValues: {
      participantEmail: data?.participantEmail || null,
      participantPhoneNumber: data?.participantPhoneNumber || null,
    },
  });

  const currentRoleTextId = getRoleTextIdVariantByParticipant(selectedRole);

  const validateIfContactEmailAlreadyExistsInLoan = (value) => {
    const emailAlreadyExistsInLoan = loan.onboarding_details.find(
      (detail) => detail.invitation.email === value
    );
    if (emailAlreadyExistsInLoan) {
      return (
        <Text
          tId={"EMAIL_SHOULD_NOT_BE_THE_SAME_AS"}
          dynamicDataTexts={[dictionaryValues[emailAlreadyExistsInLoan.role]]}
        />
      );
    }
  };

  const validateIfContactPhoneNumberAlreadyExistsInLoan = (value) => {
    const phoneNumberAlreadyExistsInLoan = loan.onboarding_details.find(
      (detail) =>
        detail.invitation.phone_number === `${PHONE_NUMBER_PREFIX}${value}`
    );
    if (phoneNumberAlreadyExistsInLoan) {
      return (
        <Text
          tId={"PHONE_NUMBER_SHOULD_NOT_BE_THE_SAME_AS"}
          dynamicDataTexts={[
            dictionaryValues[phoneNumberAlreadyExistsInLoan.role],
          ]}
        />
      );
    }
  };

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_FAMILY_SITUATION}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId={`ADD_${currentRoleTextId}`} />}
          subtitle={<Text tId={`${currentRoleTextId}_CONTACT_DATA`} />}
        />
        <TextField
          fullWidth
          label={<Text tId={`${currentRoleTextId}_PHONE_NUMBER`} />}
          type="text"
          id="participantPhoneNumber"
          name="participantPhoneNumber"
          error={errors.participantPhoneNumber ? true : false}
          helperText={errors.participantPhoneNumber?.message}
          InputProps={{
            startAdornment: (
              <InputAdornment position={"start"}>
                {PHONE_NUMBER_PREFIX}
              </InputAdornment>
            ),
          }}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
              pattern: {
                value: phonePattern,
                message: <Text tId={"INVALID_FORMAT"} />,
              },
              validate: {
                validate: (value) =>
                  validateIfContactPhoneNumberAlreadyExistsInLoan(value),
              },
            }),
          }}
        />
        <TextField
          fullWidth
          label={<Text tId={`${currentRoleTextId}_EMAIL`} />}
          type="text"
          id="participantEmail"
          name="participantEmail"
          error={errors.participantEmail ? true : false}
          helperText={errors.participantEmail?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
              pattern: {
                value: emailPattern,
                message: <Text tId={"INVALID_FORMAT"} />,
              },
              validate: {
                validate: (value) =>
                  validateIfContactEmailAlreadyExistsInLoan(value),
              },
            }),
          }}
        />
      </Box>
      <Box>
        <Box pt={3}>
          <Typography
            variant="caption"
            color="textPrimary"
            style={{
              lineHeight: 1.5,
              fontSize: 11,
              wordWrap: "anywhere",
            }}
          >
            {CAIXABANK_CO_BORROWER_NOTICE}
          </Typography>
        </Box>
        <InformationMessage
          variant={{
            type: "info",
            icon: (
              <i className="material-icons-outlined" style={{ fontSize: 20 }}>
                info
              </i>
            ),
          }}
          isScreenXs={true}
          messageContent={{
            body: (
              <Text tId={`${currentRoleTextId}_ADDITION_INFO_MESSAGE_BODY`} />
            ),
          }}
        />
        <MainButton
          disabled={loading}
          onClick={handleSubmit(() => onSubmitForm(getValues()))}
        >
          <Text tId={`ADD_${currentRoleTextId}`} />
        </MainButton>
      </Box>
    </>
  );
};
